import React from "react";
import { mergeStyles } from '@fluentui/merge-styles';
import { selectorCardStyle } from "./selectorCardStyles";

const checkboxCard = mergeStyles(selectorCardStyle, {
    selectors: {
        'input': {
            position: 'relative',
            flexShrink: 0,
            appearance: 'none',
            WebkitAppearance: 'none',
            margin: 0,
            width: 'var(--druid-checkbox-md-size)',
            height: 'var(--druid-checkbox-md-size)',
            background: 'var(--druid-selector-bg)',
            border: 'var(--druid-checkbox-border-width) solid var(--druid-selector-border-color)',
            borderRadius: 'var(--druid-checkbox-radius)',
            cursor: 'inherit',
            transition: 'background-color var(--druid-transition-fast) ease-out, border-color var(--druid-transition-fast) ease-out',
        },
        'input::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'var(--druid-selector-mark-color)',
            opacity: 0,
        },
        '&:hover input': {
            background: 'var(--druid-selector-hover-bg)',
            borderColor: 'var(--druid-selector-hover-bg)',
        },
        'input:checked': {
            background: 'var(--druid-selector-selected-bg)',
            borderColor: 'var(--druid-selector-selected-bg)',
        },
        'input:checked::after': {
            opacity: 1,
            WebkitMask: 'var(--druid-checkbox-check-icon) center / var(--druid-checkbox-check-size) no-repeat',
            mask: 'var(--druid-checkbox-check-icon) center / var(--druid-checkbox-check-size) no-repeat',
        },
        '&:hover input:checked': {
            background: 'var(--druid-selector-selected-hover-bg)',
            borderColor: 'var(--druid-selector-selected-hover-bg)',
        },
        'input:focus-visible': {
            outline: '2px solid var(--druid-selector-focus-outline-color)',
            outlineOffset: '2px',
        },
    },
});


interface BooleanSelectorProps {
    id: string;
    value: any;
    label: string;
    highlightClassName?: string;
    onChange: (styleElementName: string, value: any) => void;
}

export const BooleanSelector = (props: BooleanSelectorProps) => {
    const { id, value, label, highlightClassName, onChange } = props;
    return (
        <label className={checkboxCard}>
            <input type="checkbox" checked={!!value} onChange={e => onChange(id, e.target.checked)} />
            <span className={`${highlightClassName ? ` ${highlightClassName}` : ''}`}><strong>{label} </strong>({id})</span>
        </label>
    );
}
